import React from 'react';
import { compassFull } from '../lib/geo';

/* Compass needle pointing toward `bearingDeg` (absolute, 0=N).
   If `headingDeg` (device heading) is provided, rotates the dial so the arrow
   reflects direction relative to the user. */
export default function Compass({ bearingDeg, headingDeg = null, size = 180, label = 'DIRECTION' }) {
  const rot = bearingDeg == null ? 0 : (bearingDeg - (headingDeg ?? 0) + 360) % 360;
  const cardinal = bearingDeg == null ? '—' : compassFull(bearingDeg);
  const dialRot = headingDeg == null ? 0 : -headingDeg;
  return (
    <div className="flex flex-col items-center gap-2 select-none" data-testid="compass">
      <div className="relative" style={{ width: size, height: size }}>
        <svg viewBox="0 0 200 200" width={size} height={size}>
          <defs>
            <radialGradient id="dial" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="#141414" />
              <stop offset="100%" stopColor="#0A0A0A" />
            </radialGradient>
          </defs>
          <circle cx="100" cy="100" r="96" fill="url(#dial)" stroke="#262626" strokeWidth="2" />
          {/* Tick marks */}
          <g transform={`rotate(${dialRot} 100 100)`}>
            {Array.from({ length: 36 }).map((_, i) => {
              const isMajor = i % 9 === 0;
              return (
                <line
                  key={i}
                  x1="100"
                  y1={isMajor ? 12 : 18}
                  x2="100"
                  y2="24"
                  stroke={isMajor ? '#FF9F1C' : '#3f3f46'}
                  strokeWidth={isMajor ? 2 : 1}
                  transform={`rotate(${i * 10} 100 100)`}
                />
              );
            })}
            <text x="100" y="42" textAnchor="middle" fill="#FF9F1C" fontFamily="Chivo" fontWeight="900" fontSize="16">N</text>
            <text x="158" y="105" textAnchor="middle" fill="#71717A" fontFamily="Chivo" fontWeight="700" fontSize="12">E</text>
            <text x="100" y="172" textAnchor="middle" fill="#71717A" fontFamily="Chivo" fontWeight="700" fontSize="12">S</text>
            <text x="42" y="105" textAnchor="middle" fill="#71717A" fontFamily="Chivo" fontWeight="700" fontSize="12">W</text>
          </g>
          {/* Arrow pointing to bearing (relative to dial) */}
          <g style={{ transition: 'transform 400ms ease-out' }} transform={`rotate(${rot} 100 100)`}>
            <polygon points="100,26 88,110 100,96 112,110" fill="#FF9F1C" stroke="#0A0A0A" strokeWidth="1.5" />
            <polygon points="100,174 88,90 100,104 112,90" fill="#3f3f46" />
            <circle cx="100" cy="100" r="6" fill="#FFD166" stroke="#0A0A0A" strokeWidth="2" />
          </g>
        </svg>
      </div>
      <div className="text-center">
        <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500">{label}</div>
        <div className="font-display text-2xl font-black text-white mt-0.5" data-testid="compass-cardinal">{cardinal}</div>
      </div>
    </div>
  );
}
